module.exports = __webpack_public_path__ + "static/acs-name-medium-a949ef4a0f6e55d7f303e13f98506ca5.svg";